import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import styles from "../../snapshots.module.css";
import { InputFields, PrevHistoryContainers } from "./helper";
import { useForm, Controller } from "react-hook-form";
import Joi from "joi";
import { useUpdateAcceptRecommendation } from "@/services/snapshots/addAcceptFields.repo";
import { SnapshotChangeStatusReq } from "@/services/snapshots/addAcceptFields.repo";
import { joiResolver } from "@hookform/resolvers/joi";
import HistoryModal from "./historyModal";

/** @typedef {import('@/services/snapshots/addAcceptFields.repo').UpdateAcceptRecommendationsReq} UpdateAcceptRecommendationsReq */

/**
 * @typedef IAcceptStatusReq
 * @property {string} ticket_id
 * @property {string} ticket_url
 * @property {string} comment
 */

const AcceptStatusReq = Joi.object({
  comment: Joi.string(),
  ticket_id: Joi.string(),
  ticket_url: Joi.string(),
});

/**
 * @callback AcceptStatusCallback
 * @param {IAcceptStatusReq} values
 * @returns {void}
 */

/**
 * @typedef IAcceptComponentProps
 * @property {AcceptStatusCallback} onSubmit
 * @property {boolean} enable
 * @property {number} checkHistory
 * @property {VoidFunction} disable
 */

/**
 * @param {IAcceptComponentProps} props
 * @returns
 */
const UnarchiveModal = (props) => {
  const [enableHistoryModal, setEnableHistoryModal] = useState(false);
  // const historyModal = useHistoryModal(enableHistoryModal);

  /** @type {import('react-hook-form').UseFormReturn<UpdateAcceptRecommendationsReq>} */
  const formData = useForm({
    resolver: joiResolver(AcceptStatusReq),
    defaultValues: {},
  });

  // useEffect(() => {
  //   formData?.setValue("resourceId", props?.resourceId);
  // });

  useEffect(() => {
    if (props?.data) {
      props?.refetchTable();
      props?.disable();
      formData.resetField("comment","");
    }
    if (props?.isErrorArchive) {
      formData.resetField("comment","");
    }
    }, [props?.data,formData.resetField, props?.isErrorArchive,]);

  const handleCancel = () => {
    props?.disable();
    formData.reset(); 
    setEnableHistoryModal(false);
  };

  return (
    <Modal
      show={props?.enable}
      onHide={props?.disable}
      contentClassName={styles.modalContent}
      centered
      size={enableHistoryModal ? "lg" : "m"}
      backdrop="static"
    >
      <form
        onSubmit={formData.handleSubmit((data) => {
          props.onSubmit({
            comment: data.comment,
            ticket_id: data.ticket_id,
            ticket_url: data.ticket_url,
          });
        })}
        className={styles.contentContainer}
        style={{ width: enableHistoryModal ? "400px" : "100%" }}
      >
        <div className={styles.headerSection}>
          <p className={styles.tittle}>Unarchive {props?.name} Recommendation</p>
          <p className={styles.tagline}>
            Add details to unarchive the recommendation.{" "}
          </p>
        </div>

        <div style={{ width: "100%" }}>
          <Controller
            name="comment"
            control={formData.control}
            rules={{ required: true, minLength: 3 }}
            render={({ field }) => (
              <InputFields
                tittle={"Comment"}
                symbol={"*"}
                placeholder={"Add the Comment"}
                {...field}
                textValue={field.value}
                textChange={field.onChange}
              />
            )}
          />
          {formData?.formState?.errors?.comment && (
            <p className={styles.errorMessage}>
              {formData?.formState?.errors?.comment?.message}
            </p>
          )}
        </div>
        {/* </div> */}
        <div className={styles.buttonsContainer}>
          <button
            id={styles.AcceptId}
            className={styles.cancleButton}
            onClick={handleCancel}
            type="button"
          >
            Cancel
          </button>
          <button
            id={styles.AcceptId}
            className={styles.submitButton}
            type="submit"
          >
            Submit
          </button>
        </div>
        {props?.checkedHistory > 0 && (
          <span
            className={styles.recHistoryTittle}
            onClick={() => setEnableHistoryModal(!enableHistoryModal)}
          >
            {enableHistoryModal ? "Hide Recommendation History >" : "View Recommendation History >"}
          </span>
        )}
      </form>
      {enableHistoryModal && props?.savingid != null && (
        <HistoryModal historyData={props?.historyData} />
      )}
    </Modal>
  );
};

export default UnarchiveModal;
